export default __webpack_public_path__ + "static/media/maliha-tabassum-about-photo.c37b6428.jpg";